import { memo, type ReactNode } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";

/** A dashboard section: a semibold title above its content. Shared across the concierge analytics surfaces. */
export const AnalyticsSection = memo(function AnalyticsSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <Flex dir="column" gap="xl" w="full">
      <Text fontSize="lg" fontWeight="semibold" textColor="primary">
        {title}
      </Text>
      {children}
    </Flex>
  );
});
